function isApiErrorMessage<T extends string>(
  message: string,
  translations: { [key in T]: string },
): message is T {
  return message in translations;
}

export const getApiErrorTranslation = <T extends string>(
  message: string,
  translations: { [key in T]: string },
) => {
  if (isApiErrorMessage(message, translations)) {
    return translations[message];
  }

  return message;
};
